<template>
  <Form
    ref="form"
    class="register-form"
    :rules="registerRules"
    :model="body"
    hide-required-mark
  >
    <SwitchMode
      v-model="mode"
      :data="[
        { value: 'email', label: $t('login.use-email-register') },
        { value: 'phone', label: $t('login.use-phone-register') }
      ]"
    />
    <FormItem
      v-show="mode === 'phone'"
      :label="$t('login.phone-label')"
      prop="tel"
    >
      <PhoneInput
        v-model="body.tel"
        :placeholder="$t('login.phone-placeholder')"
      />
    </FormItem>
    <FormItem
      v-show="mode === 'email'"
      :label="$t('login.email-label')"
      prop="email"
    >
      <Input
        v-model="body.email"
        type="text"
        :placeholder="$t('login.email-placeholder')"
        required
        autofocus
      />
    </FormItem>
    <FormItem :label="$t('login.set-password-label')" prop="password_1">
      <Input
        v-model="body.password_1"
        type="password"
        autocomplete="new-password"
        :placeholder="$t('login.set-password-placeholder')"
        maxlength="24"
        required
      />
    </FormItem>
    <FormItem :label="$t('login.confirm-password-label')" prop="password_2">
      <Input
        v-model="body.password_2"
        type="password"
        autocomplete="new-password"
        :placeholder="$t('login.confirm-password-placeholder')"
        maxlength="24"
      />
    </FormItem>
    <FormItem :label="$t('login.invite-code-label')" style="margin-bottom: 5px">
      <Input
        v-model="body.invite_code"
        type="text"
        :placeholder="$t('login.invite-code-placeholder')"
      />
    </FormItem>
    <div class="footer-container">
      <div class="agreement-wrap">
        <input v-model="isAgree" type="checkbox" />
        <span class="register-statement" v-html="registerStatement" />
      </div>
      <ErrorTips v-if="error" :value="error" />
      <Button
        :disabled="isNextBtnDisabled"
        type="submit"
        :loading="loading"
        theme="primary"
        class="next-btn"
        @click="goNext"
      >
        {{ $t('login.next') }}
      </Button>
    </div>
    <div
      class="login-tips"
      @click="switchLogin"
      v-html="$t('login.loginTips')"
    />
    <GeetestCheck
      ref="geetest"
      target=".panel"
      @validate-pass="geetestPass"
      @ready="loading = false"
    />
  </Form>
</template>
<script>
import Loading from 'com/Loading'
import verifyMixin from '../verifyMixin'
import { PRIVACY_LINK, USER_AGREEMENT_LINK } from 'const/link'
import SwitchMode from '../SwitchMode'
import Form from 'com/Form'
import Button from 'com/Button'
import PhoneInput from '../PhoneInput'
import Input from 'com/Input'
import VerificationCode from '../VerificationCode'
import ErrorTips from '../ErrorTips'
import registerMixin from './registerMixin'

const FormItem = Form.Item

export default {
  name: 'RegisterPanel',
  mixins: [verifyMixin, registerMixin],
  components: {
    ErrorTips,
    VerificationCode,
    PhoneInput,
    Input,
    Form,
    Button,
    Loading,
    FormItem,
    SwitchMode
  },
  data() {
    return {
      loading: false,
      isAgree: true
    }
  },
  watch: {
    'body.email'() {
      this.$emit('reset-count-down')
    },
    'body.tel.phone'() {
      this.$emit('reset-count-down')
    },
    'body.tel.code'() {
      this.$emit('reset-count-down')
    }
  },
  activated() {
    this.resetErrors()
  },
  computed: {
    isNextBtnDisabled() {
      const { tel, email, password_1, password_2 } = this.body
      // 密码，协议
      const formDisable = !password_1 || !password_2 || !this.isAgree
      if (this.mode === 'email') {
        if (!email || formDisable) {
          return true
        }
      } else {
        if (!tel.phone || formDisable) {
          return true
        }
      }
      return false
    },
    registerStatement() {
      return this.$t('login.register-statement', {
        agreement: this.$options.filters.langParam(USER_AGREEMENT_LINK),
        privacy: this.$options.filters.langParam(PRIVACY_LINK)
      })
    }
  },
  methods: {
    switchLogin() {
      this.$emit('reset-count-down')
      this.$emit('switchLogin')
    },
    resetErrors() {
      this.clearError()
      this.$refs.form.clearErrors()
    },
    goNext() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 注册第二步仍有效
          if (this.countDown > 0) {
            this.clearError()
            this.setStep('2')
            return
          }
          this.initGeetest()
        }
      })
    }
  }
}
</script>
<style lang="less" src="./style.less"></style>
